import { DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { EmbeddedComponentLibraryExplorer } from "routes/component-library/explorer/embedded-component-library-explorer"

export function ComponentLibraryPickerDialog() {
    const { cancel } = useBoundContext()

    return (
        <Stack sx={{ overflow: "hidden", height: "85vh" }} data-cy="component-library-picker-dialog">
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Stack spacing={0.5}>
                    <Typography variant="h4">Find Tasks</Typography>
                    <Typography variant="body1" color="text.secondary">
                        Select a task to base this update on
                    </Typography>
                </Stack>
                <IconButton aria-label="Close" onClick={cancel} data-cy="close-component-library-picker">
                    <Iconify icon="eva:close-fill" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 0, overflow: "auto" }}>
                <EmbeddedComponentLibraryExplorer />
            </DialogContent>
        </Stack>
    )
}
